import store from "@/store";

let currentRequest = null;

export const refreshToken = async () => {
  if (currentRequest) {
    return currentRequest;
  }

  const requestPromise = new Promise((resolve, reject) => {
    (async () => {
      try {
        const response = await fetch(process.env.VUE_APP_API_URL + "/auth/refresh", {
          method: "POST",
          credentials: "include",
          headers: {
            "content-type": "application/json",
          },
        });

        const newRefreshToken = {
          data: await response.json(),
        };

        if (newRefreshToken.data.result !== "SUCCESS") {
          store.commit("SET_USER_ID", "");
          await this.$router.push({
            path: `/login`,
          });
        }
        resolve();
      } catch (e) {
        reject(new Error("Refresh Token Error"));
      } finally {
        currentRequest = null;
      }
    })();
  });

  currentRequest = requestPromise;

  return requestPromise;
};
